<template>
	<div>
		<!-- <el-select v-model="consolelanguage" :placeholder="$store.state.consolelanguagedata.select">
			<el-option v-for="item in ['汉语','English']" :key="item" :label="item" :value="item">
			</el-option>
		</el-select> -->
	</div>
</template>

<script>
	import consolelanguagechian from '../../assets/json/chian.json'
	import consolelanguageenglish from '../../assets/json/english.json'
	export default {
		name: 'Study',
		data() {
			return {
				consolelanguage:localStorage.getItem("consolelanguage")?JSON.parse(localStorage.getItem("consolelanguage")):'汉语',
			}
		},
		watch:{
			consolelanguage(val){
				if(val=='汉语'){
					localStorage.setItem("consolelanguage",JSON.stringify(val))
					this.$store.commit('consolelanguagedatashow',consolelanguagechian)
          window.location.reload()
				}else{
					localStorage.setItem("consolelanguage",JSON.stringify(val))
					this.$store.commit('consolelanguagedatashow',consolelanguageenglish)
          window.location.reload()
				}
			}
		},
		mounted(){
			if(this.consolelanguage=='汉语'){
				this.$store.state.consolelanguagedata=consolelanguagechian
			}else{
				this.$store.state.consolelanguagedata=consolelanguageenglish
			}
		}
	}
</script>

<style>
</style>
